import ky from 'ky';

import { AuthService } from '@/entities/auth/auth-service';

export const internalApiClient = ky.create({
  prefix: `${import.meta.env.VITE_SOCIAL_API_BASE_URL}/admin`,
  hooks: {
    beforeRequest: [
      ({ request }) => {
        const token = AuthService.getTokens()?.accessToken;
        if (token != null) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
  },
  retry: {
    limit: 2,
  },
  timeout: 120_000,
});
